export default class Collapsables {
    constructor($el) {
        this.$el = $el;

        this.$collapsables = this.$el.querySelectorAll('[data-collapsable]');



        this.$top = this.$el.querySelector('[data-collapsable-top]');
        this.$body = this.$el.querySelector('[data-collapsable-body]');
        this.$icon = this.$el.querySelector('[data-collapsable-icon]');

        this.init = this.init.bind(this);
        this.setState = this.setState.bind(this);
        this.init();

    }

    init() {
        this.$collapsables.forEach((collapsable) => {
            var collapsableTop = collapsable.querySelector('[data-collapsable-top]');
            var collapsableBody = collapsable.querySelector('[data-collapsable-body]');

            collapsableTop.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeAll(collapsable);
                this.setState(collapsableTop, collapsableBody, !collapsableBody.classList.contains('collapsable__item__text--open'));
            });

            collapsableTop.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && collapsableBody.classList.contains('collapsable__item__text--open')) {
                    e.preventDefault();
                    this.setState(collapsableTop, collapsableBody, false);
                    collapsableTop.focus();
                }
            });
        })
    }

    setState(collapsableTop, collapsableBody, isOpen) {
        collapsableBody.classList.toggle('collapsable__item__text--open', isOpen);
        collapsableTop.classList.toggle('collapsable__item__top--open', isOpen);
        collapsableTop.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        collapsableBody.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

        const label = isOpen ? collapsableTop.dataset.labelClose : collapsableTop.dataset.labelOpen;

        if (label) {
            collapsableTop.setAttribute('aria-label', label);
            collapsableTop.setAttribute('title', label);
        }
    }

    closeAll(activeCollapsable) {
        this.$collapsables.forEach((collapsable) => {
            if(collapsable !== activeCollapsable) {
                var collapsableTop = collapsable.querySelector('[data-collapsable-top]');
                var collapsableBody = collapsable.querySelector('[data-collapsable-body]');
                this.setState(collapsableTop, collapsableBody, false);
            }
        });
    }
}
